import { Row, Col, Container, Card, Button, Table, Dropdown, Form, Spinner, Modal } from "react-bootstrap";
import Layout from "../../components/Layout";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { useEffect, useRef, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { addCustomer, deleteCustomerById, getCustomersList } from "../../redux/slices/users";
import Swal from "sweetalert2";
import { managerAddCustomer, managerDeleteCustomerById, managerGetCustomersList } from "../../redux/slices/managers.slice";
import { contactlistUpload } from "../../redux/slices/account.service";

const Customers = () => {

    const dispatch = useDispatch()
    const isLoaded = useRef(false)

    const { user = {} } = useSelector((state) => state.auth)
    const { business = {} } = useSelector((state) => state.user)

    const initialState = {
        modalShow: false,
        showBalance: false,
        customers: [],
        customer: {},
        loading: false,
        payload: {},
        errors: {},
        contactlist: "",
        showUploadForm: false,
    }

    const [state, setState] = useState(initialState)

    useEffect(() => {
        if(!isLoaded.current) {
            getCustomers()
            isLoaded.current = true
        }
    }, [])

    const selectCustomer = (id) => {
        const customer = state.customers.filter(item => item.id === id)[0]
        setState((prevState) => ({...prevState, modalShow: true, customer: customer }))
    }

    const handleInput = (event) => {
        const { name, value } = event.target
        setState((prevState)=> ({...prevState, payload:{...prevState.payload, [name]: value}}))
    }

    const handleValidation = (event) => {

        const regex = /^\d*\.?\d*$/;
        const pattern = /[a-zA-Z0-9]+[\.]?([a-zA-Z0-9]+)?[\@][a-z]{3,9}[\.][a-z]{2,5}/g;
    
        const {name, value} = event.target
        if(value === '' && event.target.attributes.required) {
            event.target.style = "border: 1px solid red"
            setState((prevState) => ({ ...prevState, errors: {...prevState.errors, [name]: `${name[0].toUpperCase() + name.split('_').join(' ').slice(1)} is required`}}))
        }

        else if (name ==='amount' && !regex.test(parseFloat(value.replace(/[^\d.]/g, '')))) {
            event.target.style = "border: 1px solid red"
            setState((prevState) => ({ ...prevState, errors: {...prevState.errors, [name]: `${name[0].toUpperCase() + name.split('_').join(' ').slice(1)} is required`}}))
        }
        else {
            event.target.style = "border-style: transparent"
            delete state.errors[name]
            setState((prevState) => ({ ...prevState, errors: {...prevState.errors}}))
        }
    }

    const getCustomers = () => {
        const action = user?.user_type === 'owner' ? getCustomersList() : managerGetCustomersList()
        dispatch(action)
        .then((response) => {
            if(response?.payload?.results) {
                const customers = response.payload.results
                setState((prevState) => ({...prevState, customers: customers}))
            } else {
                Swal.fire({
                    title: 'Error!',
                    text: response?.payload?.message || 'An error occured',
                    icon: 'error',
                    confirmButtonText: 'Ok'
                })
            }
        })
    }

    const createCustomer = () => {
        setState((prevState) => ({...prevState, loading: true}))
        let request_payload = state.payload
        request_payload.full_name = state.payload.first_name+' '+state.payload.last_name
        const action = user?.user_type === 'owner' ? addCustomer(request_payload) : managerAddCustomer(request_payload)
        dispatch(action)
        .then((response) =>  {
            if(response.payload?.success === true) {
                Swal.fire({
                    icon: 'success',
                    text: response.payload?.message
                })
                setState((prevState) => ({...prevState, showBalance: false }))
                getCustomers()
            }
            else {
                Swal.fire({
                    icon: 'error',
                    text: response?.payload?.message || 'An error occured'
                })
            }
        })
        .finally(() => setState((prevState) => ({...prevState, loading: false })))
    }

    const deleteCustomer = (id) => {
        Swal.fire({
            title: 'Are you sure?',
            icon: 'warning',
            showCancelButton: true,
            confirmButtonText: 'Yes, delete it!',
            cancelButtonText: 'No, keep it'
        })
        .then((result) => {
            if (result.isConfirmed) {
                const action = user?.user_type === 'owner' ? deleteCustomerById(id) : managerDeleteCustomerById(id)
                dispatch(action)
                .then((response) => {
                    if(response?.payload?.success === true) {
                        getCustomers()
                        Swal.fire({
                            icon: 'success',
                            text: response?.payload?.message || 'Customer removed sucessfully'
                        })
                    }
                    else {
                        Swal.fire({
                            icon: 'error',
                            text: response?.payload?.message || 'Could not remove customer'
                        })
                    }
                })
            }
        })
    }

    const uploadContacts = () => {
        let formdata = new FormData()
        formdata.append('contact_list', state.contactlist)
        Swal.fire({
            icon: 'warning',
            text: 'The entries in the selected document will be uploaded and added to your customer list. Do you wish to proceed?',
            showCancelButton: true,
            cancelButtonText: 'No, Cancel',
            showConfirmButton: true,
            confirmButtonText: 'Yes, Proceed'
        })
        .then((result) => {
            if(result.isConfirmed) {
                setState((prevState) => ({...prevState, loading: true}))
                let requestPayload = {
                    contactlist: formdata,
                    user_type: user?.user_type,
                    merchant_id: business?.merchant_id
                }
                dispatch(contactlistUpload(requestPayload))
                .then((response) => {
                    if(response.payload?.success === true) {
                        Swal.fire({
                            icon: 'success',
                            text: response.payload?.message || 'Contacts uploaded'
                        })
                        getCustomers()
                    }
                    else {
                        Swal.fire({
                            title: 'Error',
                            icon: 'error',
                            text: response.payload?.message || 'Could not upload contacts'
                        })
                    }
                })
                .finally(() => setState((prevState) => ({...prevState, loading: false})))
            }
        })
    }

    const handleFileSelect = (event) => {
        const file = event.target.files[0];
        const reader = new FileReader();
        reader.readAsDataURL(file);
        reader.onload = (e) => {
            setState((prevState) => ({...prevState, contactlist: file }))
        };
    }
 
    return (
        <Layout>
            <Container className="mt-4 px-4 mb-4">
                <Col md={12} className="d-flex align-items-center justify-content-between">
                    <h3>All Customers</h3>
                    <div>
                        <Button 
                            type="button" 
                            variant="primary" 
                            onClick={ () => setState((prevState) => ({...prevState, showUploadForm: true}))}
                            className="me-2"
                        >
                            <FontAwesomeIcon icon={'users'} />
                            <span className="ps-2">Add Bulk Customer</span>
                        </Button>
                        <Button 
                            type="button" 
                            variant="primary" 
                            onClick={ () => setState((prevState) => ({...prevState, showBalance: true}))}
                        >
                            <FontAwesomeIcon icon={'plus'} />
                            <span className="ps-2">Add a customer</span>
                        </Button>
                    </div>
                </Col>

                <div className="mt-4">
                    <Card className="border-0 shadow-sm">
                        <Card.Body className="table-responsive-lg">
                            <Table size="sm" className="table-color">
                                <thead>
                                    <tr>
                                        <th>Name</th>
                                        <th>Email</th>
                                        <th>Mobile Phone</th>
                                        <th>Action</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    {
                                        state.customers?.length ? (
                                            state.customers?.map((item, index) => (
                                                <tr key={index}>
                                                    <td>
                                                        <p className="m-0 d-flex gap-2 align-items-center">
                                                            <img 
                                                                src={item.avatar || 'https://placehold.co/50'} 
                                                                alt="avatar" 
                                                                width="30" 
                                                                className="rounded-circle"
                                                            />
                                                            <strong>
                                                                {item.full_name }
                                                            </strong>
                                                        </p>
                                                    </td>
                                                    <td>
                                                        {item.email}
                                                    </td>
                                                    <td>
                                                        {item.mobile}
                                                    </td>
                                                    <td>
                                                        <p className="d-flex m-0 align-items-center justify-content-between">
                                                            <Dropdown>
                                                                <Dropdown.Toggle variant="light" className="border-0 bg-white" size="sm" id="dropdown-basic">
                                                                    <FontAwesomeIcon icon="ellipsis-vertical" style={{fontSize: "20px"}} className="text-muted"/>
                                                                </Dropdown.Toggle>

                                                                <Dropdown.Menu className="border-0 shadow px-3 py-4">
                                                                    <Dropdown.Item 
                                                                        eventKey={2} 
                                                                        className="d-flex align-items-center gap-1 text-danger"
                                                                        onClick={ () => deleteCustomer(item.id) }
                                                                    >
                                                                       <FontAwesomeIcon icon={'trash'} className="text-danger" />
                                                                        Remove customer
                                                                    </Dropdown.Item>
                                                                </Dropdown.Menu>
                                                            </Dropdown>
                                                        </p>
                                                    </td>
                                                </tr>
                                            )
                                        ))
                                        :
                                        (
                                            <tr>
                                                <td colSpan={5} className="text-center text-muted">No data found</td>
                                            </tr>
                                        )
                                    }
                                </tbody>
                            </Table>
                        </Card.Body>
                    </Card>
                </div>

                <Modal
                    show={state.modalShow}
                    onHide={() => setState((prevState) => ({...prevState, modalShow: false }))}
                    size="lg"
                    backdrop="static"
                >
                    <Modal.Header className="bg-primary text-white" closeButton>
                        <Modal.Title as={"h5"}>{state.customer?.name}</Modal.Title>
                    </Modal.Header>
                    <Modal.Body>
                        <Row>
                            <Col md={6}>
                                <div className="modal-profile">
                                    <ul>
                                        <li>
                                            <div>
                                                <p className="pt-2">
                                                    <small className="text-muted">Customer Email</small>
                                                    {state.customer?.email} 
                                                </p>
                                            </div>
                                        </li>
                                    </ul>

                                </div>
                            </Col>
                            <Col md={6} className="modal-profile">
                                <ul>
                                    <li>
                                        <div>
                                            <p className="pt-2">
                                                <small className="text-muted">Customer Phone Number</small>
                                                {state.customer?.phone}
                                            </p>
                                        </div>
                                    </li>
                                </ul>
                            </Col>
                        </Row>
                    </Modal.Body>
                </Modal>

                <Modal
                    show={state.showBalance}
                    onHide={() => setState((prevState) => ({...prevState, showBalance: false }))}
                    size="md"
                    backdrop="static"
                >
                    <Modal.Header className="bg-primary text-white" closeButton>
                        <Modal.Title as={"h5"}>Add Customer</Modal.Title>
                    </Modal.Header>
                    <Modal.Body>
                        <Form>
                            <p className="text-sm">Add a new customer</p>
                            <Row>
                                <Form.Group as={Col} md="12" className="mb-3">
                                    <Form.Label className="mb-0">First Name</Form.Label>
                                    <Form.Control
                                        type="text"
                                        required
                                        placeholder="First name"
                                        name="first_name"
                                        onChange={handleInput}
                                        onKeyUp={handleValidation}
                                    />
                                    {
                                        state.errors['first_name'] && 
                                        <Form.Text className="text-danger">{state.errors['first_name']}</Form.Text>
                                    }
                                </Form.Group>
                                <Form.Group as={Col} md="12" className="mb-3">
                                    <Form.Label className="mb-0">Last Name</Form.Label>
                                    <Form.Control
                                        type="text"
                                        required
                                        placeholder="Last name"
                                        name="last_name"
                                        onChange={handleInput}
                                        onKeyUp={handleValidation}
                                    />
                                    {
                                        state.errors['last_name'] && 
                                        <Form.Text className="text-danger">{state.errors['last_name']}</Form.Text>
                                    }
                                </Form.Group>

                                <Form.Group as={Col} md="12" className="mb-3">
                                    <Form.Label className="mb-0">Email</Form.Label>
                                    <Form.Control
                                        type="email"
                                        required
                                        placeholder="xyz@me.com"
                                        name="email"
                                        onChange={handleInput}
                                        onKeyUp={handleValidation}
                                    />
                                    {
                                        state.errors['email'] && 
                                        <Form.Text className="text-danger">{state.errors['email']}</Form.Text>
                                    }
                                </Form.Group>

                                <Form.Group as={Col} md="12" className="mb-3">
                                    <Form.Label className="mb-0">Phone Number</Form.Label>
                                    <Form.Control
                                        type="tel"
                                        required
                                        placeholder="phone number"
                                        name="phone"
                                        onChange={handleInput}
                                        onKeyUp={handleValidation}
                                    />
                                    {
                                        state.errors['phone'] && 
                                        <Form.Text className="text-danger">{state.errors['phone']}</Form.Text>
                                    }
                                </Form.Group>

                                <Form.Group 
                                    as={Col} 
                                    md="12" 
                                    controlId="validationCustom011" 
                                    className="mt-4 d-grid"
                                >
                                    <Button 
                                        variant="primary" 
                                        size="lg" 
                                        onClick={createCustomer}
                                        disabled={Object.keys(state.errors).length > 0}
                                    >
                                        Create Customer <Spinner animation={ state.loading ? "border" : null} role="status" size="sm"></Spinner>
                                    </Button>
                                </Form.Group>
                            </Row>
                        </Form>
                    </Modal.Body>
                </Modal>

                <Modal
                    show={state.showUploadForm}
                    onHide={() => setState((prevState) => ({...prevState, showUploadForm: false }))}
                    size="md"
                    backdrop="static"
                >
                    <Modal.Header className="bg-primary text-white" closeButton>
                        <Modal.Title as={"h6"} className="p-0">Upload Customer Details</Modal.Title>
                    </Modal.Header>
                    <Modal.Body>
                        <Form>
                            <p className="text-right">
                                <a 
                                    download={true} 
                                    href="https://bs-staging.wallx.co/biz/course_material/Contact_List.xlsx"
                                    
                                    target="_blank"
                                >
                                    Download template
                                </a>
                            </p>
                            <Row>
                                <Form.Group as={Col} md={12} lg={12} sm={12} className="mb-3">
                                    <Form.Label className="mb-0 text-sm">Contact list</Form.Label>
                                    <label htmlFor="contact_list" className="custom-file-select form-control">
                                        <FontAwesomeIcon icon="fa fa-cloud" /> Select Document
                                        <Form.Control
                                            type="file"
                                            name="contact_list"
                                            onChange={handleFileSelect}
                                            id="contact_list"
                                            accept="application/vnd.openxmlformats-officedocument.spreadsheetml.sheet"
                                        />
                                    </label>
                                    <p className="px-1 m-0 text-secondary text-sm">Only .xlsx file type is allowed.</p>
                                </Form.Group>
                            </Row>
                        </Form>
                    </Modal.Body>
                    <Modal.Footer>
                         <Button 
                            type="button" 
                            variant="primary"
                            onClick={uploadContacts}
                            disabled={ state.contactlist === ' ' || state.contactlist === undefined ? true : false }
                        >
                            Upload Contacts <Spinner animation={ state.loading ? "border" : null} role="status" size="sm"></Spinner>
                        </Button>
                    </Modal.Footer>
                </Modal>
            </Container>
        </Layout>
    );
}

export default Customers;